import type { ImageBlock, TextBlock } from '../../store/chatStore';

// Pleri starts every tool result it moved out of a long conversation with this.
const MOVED_TOOL_OUTPUT_MARKER = '[Tool output moved out of the conversation]';
const SAVED_AT = / saved at (\S+?):/;

const textOf = (content: string | Array<TextBlock | ImageBlock> | undefined) =>
  typeof content === 'string'
    ? content
    : (content ?? [])
        .map((block) => (block.type === 'text' ? block.text : ''))
        .join('');

/**
 * Reads a tool result Pleri moved out of the conversation to stay within the
 * model's context limit. Undefined for an ordinary tool result.
 */
export const readMovedToolOutput = (
  content: string | Array<TextBlock | ImageBlock> | undefined,
): { location: string | undefined } | undefined => {
  const text = textOf(content);
  if (!text.startsWith(MOVED_TOOL_OUTPUT_MARKER)) {
    return undefined;
  }
  return { location: SAVED_AT.exec(text)?.[1] };
};
